module.exports = __webpack_public_path__ + "img/smallLogo.a314ba74.webp";